import {Pipe, PipeTransform} from "@angular/core";
import {Order} from "../../store/state/order.state";

@Pipe({
    name: 'totalPrice',
    standalone: false
})
export class TotalOrderPricePipe implements PipeTransform {

	transform(order: Order): number {
		return order.products.map(product => product.pricing.totalPrice).reduce((p1, p2) => p1 + p2, 0);
	}
}
